<template>
    <div class="staff-form-loader">
        <div v-for="n in 3" :key="n" class="staff-form-loader__form-item">
            <CompassSkeleton size="large" class="staff-form-loader__form-label" />
            <CompassSkeleton size="x-large" class="staff-form-loader__form-input" />
        </div>
    </div>
</template>
<style lang="scss" scoped>
.staff-form-loader {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3);

    &__form {
        &-item {
            display: flex;
            flex-direction: column;
            gap: var(--spacing-0);
        }

        &-label {
            width: 30%;
        }
    }
}
</style>
